import { apiPost } from '../../api'

export const save_greenlight_survey = data =>
  apiPost({
    endpoint: 'greenlight/save_survey',
    data: data
  })
